export * from './secret';

export const IS_SERVER = typeof window === 'undefined';
